import { Dialog } from "@mui/material";
import { styled } from "@mui/material/styles";

export const WideDialog = styled(Dialog)({
  "& .MuiPaper-root.MuiPaper-elevation": {
    width: "100%",
    margin: 0,
    maxWidth: "90vw",
  },
});
